module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-10.88c5b37d.png";